import useSWR from 'swr'

import { getInvoiceHistory } from '../../api'
import { useAuth } from '../../context/auth'
import * as dateLib from '../../lib/dates'
import Spinner from '../ui/spinner'
import List from '../ui/list'
import PageSectionTitle from '../ui/pageSectionTitle'

type Props = {
  invoiceId: string
}

const InvoiceHistory: React.FC<Props> = ({ invoiceId }) => {
  const { user } = useAuth()
  const { data: historyResponse, isLoading } = useSWR(`/api/invoices/${invoiceId}/history`, getInvoiceHistory)

  const headers = [
    { label: 'Activity' },
    { label: 'Date' },
  ]
  const rows = historyResponse?.data && historyResponse?.data.map((item: any) => {
    return [
      <div>{item.message}</div>,
      <small>{dateLib.formatDateShort(item.createdDate, user?.locale)}</small>
    ]
  })
  if(!rows || rows.length === 0) { return null }
  return (
    <div>
      <PageSectionTitle title='Activity' />
      {isLoading ? (<Spinner />) : (
        <div className='mt-3'>
          <List headers={headers} rows={rows} hideHeaders />
        </div>
      )}
    </div>
  )
}

export default InvoiceHistory
